import { render, staticRenderFns } from "./SupplierEdit.vue?vue&type=template&id=539ed046&scoped=true"
import script from "./SupplierEdit.vue?vue&type=script&lang=js"
export * from "./SupplierEdit.vue?vue&type=script&lang=js"
import style0 from "./SupplierEdit.vue?vue&type=style&index=0&id=539ed046&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539ed046",
  null
  
)

export default component.exports